export enum DriverAggregation {
  Average = 0,
  Sum = 1,
  Scripted = 2,
  Min = 3,
  Max = 4,
}

export enum DriverVarType {
  SingleProp = 0,
  TransformChan = 1,
  RotDiff = 2,
  LocDiff = 3,
  ContextProp = 4,
}

export enum FCurveInterpolation {
  Constant = 0,
  Linear = 1,
  Bezier = 2,
}

export enum HandleType {
  Free = 0,
  Auto = 1,
  Vector = 2,
  Aligned = 3,
  AutoClamped = 4,
}

export interface FCurvePoint {
  co: [number, number];
  leftHandle: [number, number];
  rightHandle: [number, number];
  interpolation: FCurveInterpolation;
  handleTypeLeft: HandleType;
  handleTypeRight: HandleType;
}

export interface FCurveMapping {
  points: FCurvePoint[];
}

export interface BlendDriverTarget {
  datablockName: string;
  rnaPath: string | null;
  boneName: string | null;
  transformChannel: number | null;
}

export interface BlendDriverVariable {
  name: string;
  type: DriverVarType;
  targets: BlendDriverTarget[];
}

export interface BlendDriver {
  targetPath: string;
  arrayIndex: number;
  aggregation: DriverAggregation;
  variables: BlendDriverVariable[];
  fcurveMapping: FCurveMapping | null;
}
